module.exports = __webpack_public_path__ + "static/BeaconDA-Medium-91a73d6eaf91dadc78804b763b2cc447.otf";